module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seat-pad-flyo-977d10146c0924672990a389a36d81b5.svg";